import * as React from 'react';
import { Image } from '@/hen-ui/atomics/Image';
import { cn } from '@/hen-ui/utils';

export type HeroProps = {
  imgSrc: string;
  imgAlt?: string;
  variant?: 'img-left' | 'img-right';
  className?: string;
  imgClass?: string;
  backgroundImage?: string;
  contentGap?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  children: React.ReactNode;
};

const gapClasses = {
  xxs: 'gap-xxs',
  xs: 'gap-xs',
  sm: 'gap-sm',
  md: 'gap-md',
  lg: 'gap-lg',
  xl: 'gap-xl',
  '2xl': 'gap-2xl',
  '3xl': 'gap-3xl',
} as const;

export const Hero: React.FC<HeroProps> = ({
  imgSrc,
  imgAlt,
  variant = 'img-left',
  className,
  imgClass,
  backgroundImage,
  contentGap = 'xxs',
  children,
}) => {
  return (
    <div className={cn('relative', className)}>
      {backgroundImage && (
        <Image
          src={backgroundImage}
          alt=''
          className='absolute inset-0 -z-10 h-full w-full object-cover'
        />
      )}
      <div
        className={cn(
          `flex flex-col-reverse items-center justify-center gap-max ${variant === 'img-left' ? 'md:flex-row' : 'md:flex-row-reverse'}`,
        )}
      >
        <div className='flex w-full md:w-1/2 justify-center md:justify-end'>
          <div className='relative w-full h-auto rounded-xl overflow-hidden'>
            <Image
              src={imgSrc}
              className={imgClass}
              alt={imgAlt ? imgAlt : 'Hero Image'}
            />
          </div>
        </div>
        <div
          className={cn(
            'flex flex-col w-full md:w-1/2 text-left',
            gapClasses[contentGap],
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

Hero.displayName = 'Hero';
